import { render, staticRenderFns } from "./applyForDepositWithdrawalModification.vue?vue&type=template&id=1ca25131&scoped=true&"
import script from "./applyForDepositWithdrawalModification.vue?vue&type=script&lang=js&"
export * from "./applyForDepositWithdrawalModification.vue?vue&type=script&lang=js&"
import style0 from "./applyForDepositWithdrawalModification.vue?vue&type=style&index=0&id=1ca25131&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca25131",
  null
  
)

export default component.exports